export const EClassPageView = {
  Class: 1,
  Test: 2
}

export default EClassPageView
